export default [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
]
